import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import photo from "../../Assets/2.png";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              <span className="purple"> About Me </span>
            </h1>
            <div className="home-about-body">
              <blockquote className="blockquote mb-0">
                <p style={{ textAlign: "justify" }}>
                  <span>
                    {" "}
                    I've always been fascinated by computers and the technical
                    mechanics behind the monitor. Passionate about implementing
                    and working on new projects.
                  </span>
                  <br />
                  <br />
                  Quick learner and an aspiring full-stack web developer with
                  core knowledge of MERN stack technology. Looking forward to
                  applying and enhancing my skills and knowledge as a developer.
                </p>

                <footer className="blockquote-footer">Vishal</footer>
              </blockquote>
            </div>

            <Card.Text style={{ textAlign: "center", padding: "2rem" }}>
              <Button
                variant="primary"
                target="_blank"
                href="https://drive.google.com/file/d/1uWhyVgoG90Uw8EakVDIeIL1Y4N7M_cV3/view?usp=share_link"
                // href="https://drive.google.com/file/d/16OX4u_WgtAiaXIky1zEYISl2y-lTjjR8/view?usp=sharing"
              >
                View Resume
              </Button>
              <Button
                href="./Vishal_Bhuse_Resume.pdf"
                download
                variant="primary"
                style={{ marginLeft: "20px" }}
              >
                Download Resume
              </Button>
            </Card.Text>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={photo} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
